import {
  EIntakeStep,
  IApplication,
} from "@rentiohq/shared-frontend/dist/types/application.types";
import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { IBroker } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";

export interface IExtraData {
  property: IProperty;
  /** The step being moved to, which decides whether a link marker is required. */
  step: EIntakeStep;
  applications: IApplication[];
  user: IUser;
  // The authenticated broker (from useSelf) — reliably includes `features`,
  // unlike the broker embedded on an application, which is not fetched with
  // its features and would make the RentMatch booking URL fall back to the
  // mijnhuurprofiel domain.
  broker?: IBroker;
  localeMessages: { [key: string]: string | undefined };
}

/**
 * One field per language present in the selection, rather than one field for
 * everybody.
 *
 * The candidates moving to the next step do not necessarily share a language,
 * and each is sent the text of their own. A single box could only ever be right
 * for some of them, and the broker could not see, let alone reach, what the
 * others were going to get.
 */
export const getFeedbackFieldForLocale = (locale: string) =>
  `tenantFeedbackText_${locale}`;
